import { useQuery } from '@tanstack/react-query';

import API from '@/config/api';

import { dependenciesResponse, type UseDependencies } from './Dependencies.schema';

const DEPENDENCIES_QUERY_KEY = ['dependencies'];

export const dependenciesKeys = {
	all: DEPENDENCIES_QUERY_KEY,
	list: () => [...DEPENDENCIES_QUERY_KEY, 'list'] as const,
};

export const useDependencies = (opts: UseDependencies['opts'] = {}) =>
	useQuery<UseDependencies['response']>({
		...opts,
		queryKey: dependenciesKeys.list(),
		queryFn: () => API.get('/dependencies').then((res) => dependenciesResponse.parse(res.data)),
		// The backend caches the probe + stats roll-up for ~30s (the
		// collectors are heavier than a ping), so polling faster just hits
		// that cache. Match it: 30s stale, 30s refetch.
		staleTime: 30_000,
		refetchInterval: 30_000,
	});
